import { filtersListAtom } from '@core/Atoms/Plp/FiltersListAtom';
import { atomWithDefault } from 'jotai/utils';

export type PriceTypeAtom = 'monthly-price' | 'price';

export const priceTypeAtom = atomWithDefault(get => {
  const filters = get(filtersListAtom);
  const hasMonthlyFilter = filters?.some(filter => filter.id.includes('monthly'));
  return hasMonthlyFilter ? 'monthly-price' : 'price';
});
